export const AppLinkageSettings = {
  title: '他アプリとの連携',
  errMessage: {
    noAppCanBeLinked: '連携可能なアプリがありません。',
  },
  iosHealthCare: {
    title: 'ヘルスケアを有効化する',
    message:
      '「ヘルスケア」と連携することで健康データを表示することができます。「ヘルスケア」側の設定で許可されていないと連携することはできません。連携できない場合、「設定」アプリから「プライバシー」→「ヘルスケア」→ 「タヨリス」を開いて設定してください。最大で直近1か月のデータを取得します。',
  },
  googleFit: {
    title: 'Google Fitを有効化する',
    message:
      '「Google Fit」は、複数のアプリやデバイスからフィットネスデータを管理できるオープンプラットフォームです。\r\n「Google Fit」と連携することで健康データを表示することができます。最大で直近1か月のデータを取得します。\r\n有効化を解除すると「Google Fit」との接続をいつでも解除できます。',
  },
  omronConnect: {
    title: 'OMRON connectを有効化する',
    message:
      '「OMRON connect」と連携することで健康データを表示することができます。本アプリと「Google Fit」が連携済みで「OMRON connect」と「Google Fit」が連携されている場合、「歩数」と「体重」が重複して取得されるため、どちらかの連携を解除する必要があります。最大で直近1か月のデータを取得します。',
  },
  fitbit: {
    title: 'Fitbitと連携する',
    message:
      'Fitbitから取得する項目を変更したい場合は、一度チェックを外してから再度チェックを入れて取得項目の再設定してください。',
    authMessageDialog: {
      successMessage: 'Fitbitアカウント連携が完了しました。',
      errorMessage: 'Fitbitアカウント連携に失敗しました。',
    },
  },
};
